import Vue from "vue";
import Router from "vue-router";
import Home from "@/page/Home";
import Resume from "@/page/Resume";
import Terms from "@/page/Terms";
import Garden from "@/page/Garden";
import Thankyouscuf from "@/page/Thankyouscuf";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    { path: "/", redirect: "/home/1" },
    {
      path: "/home/:id",
      name: "Home",
      component: Home
    },
    {
      path: "/garden",
      name: "Garden",
      component: Garden
    },
    {
      path: "/resume",
      name: "Resume",
      component: Resume
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms
    },
    {
      path: "/scuf-case-study",
      name: "Thankyouscuf",
      component: Thankyouscuf
    }
  ],
  scrollBehavior() {
    window.scrollTo(0,0);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js